import React, { useState } from "react";
import { X } from "lucide-react";
import { CreateLogForm } from "./CreateLogForm.jsx";

// Default form state for creating a new change log entry
const CREATE_LOG_DEFAULTS = {
  title: "",
  entityName: "",
  status: "Pending",
  changeType: "Routing Change",
  changeCategory: "Planned",
  change: { before: "", after: "", description: "" },
  revenueImpact: { projectedUplift: 0, currency: "USD", timeframe: "Monthly", confidence: "Medium" },
  expectedOutcome: "",
  query: { baseUrl: null, params: {} },
  observationWindow: { startDate: null, endDate: null, durationDays: 30, status: "Active" },
  tags: [],
  details: {},
};

export function CreateLogModal({ isOpen, onClose, onSave }) {
  const [formData, setFormData] = useState(() => ({
    ...CREATE_LOG_DEFAULTS,
  }));
  const [newTag, setNewTag] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm p-4 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="create-log-title"
      onKeyDown={(e) => e.key === "Escape" && onClose?.()}
    >
      <div className="bg-card text-card-foreground border border-border rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-border flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h2
              id="create-log-title"
              className="text-xl font-semibold tracking-tight"
            >
              Create New Log Entry
            </h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="btn btn-ghost h-9 w-9 p-0"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="overflow-y-auto max-h-[calc(90vh-88px)]"
        >
          <CreateLogForm
            formData={formData}
            setFormData={setFormData}
            newTag={newTag}
            setNewTag={setNewTag}
          />

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border bg-muted/40">
            <button type="button" onClick={onClose} className="btn btn-ghost">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Create Log
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
